/* eslint-disable */

import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
export default {
  components: {
    customModal,
    VPagination
  },
  props: {
    subjectId: {
      type: String,
      default: ""
    },
    aetype: {
      type: String,
      default: ""
    },
    tableName: {
      type: String,
      default: "AE Data"
    },
    fromPage: {
    type: String,
    default: ""
  }
  },
  data() {
    return {
      auditData: [],
      baseapi: process.env.VUE_APP_Service_URL,
      defaultdate:"",
      tableData: [],
      tableLoading: false,
      aeTimelineCurrentPage: 1,
      aeTimelinePageSize: 10,
      aeTimelineTotalPages: 0
    };
  },
mounted() {
  this.defaultdate = localStorage.getItem("dateformat");
  console.log("frompage", this.fromPage);
  this.getAetimeline();
},
watch: {
  subjectId() {
    this.aeTimelineCurrentPage = 1;
    this.getAetimeline(1);
  },
  aetype() {
    this.aeTimelineCurrentPage = 1;
    this.getAetimeline(1);
  }
},
methods: {
   async getAetimeline(page = this.aeTimelineCurrentPage) {
    let url = "";
      if (!this.subjectId) {
        url =    `${this.baseapi}/forms/reports/aetimeline?aefilter=${this.aetype || ""}&pageindex=${page}&pagesize=${this.aeTimelinePageSize}&studyId=${store.getters.getStudyIs || ""}`;

        this.tableData = [];
        this.aeTimelineTotalPages = 0;
       
      }
      else {
        url = `${this.baseapi}/forms/reports/aetimeline?subjectId=${this.subjectId}&aefilter=${this.aetype || ""}&pageindex=${page}&pagesize=${this.aeTimelinePageSize}`;
      }
      const token = store.getters.getIdToken;
      this.aeTimelineCurrentPage = page;
      this.tableLoading = true;
      this.tableData = [];

      try {
        const res = await axios.get(
          url,
          { headers: { Authorization: "Bearer " + token } }
        );
        const results = res.data.results || [];
        const totalCount =
          res.data.totalCount !== undefined && res.data.totalCount !== null
            ? res.data.totalCount
            : res.data.count !== undefined && res.data.count !== null
              ? res.data.count
              : results.length;

        this.tableData = results;
        this.aeTimelineTotalPages = totalCount
          ? Math.ceil(totalCount / this.aeTimelinePageSize)
          : 0;
      } catch (error) {
        console.error("Error fetching AE timeline data:", error);
        this.tableData = [];
        this.aeTimelineTotalPages = 0;
      } finally {
        this.tableLoading = false;
      }
    },
   loadAeTimelinePage(page) {
      this.getAetimeline(page);
    },
   formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    viewforms(formid){
      this.$emit("viewform", formid);
    }
}
};
